import { Component, input } from '@angular/core'
import { RouterLink } from '@angular/router'

import { TranslatePipe } from '@ngx-translate/core'

@Component({
  selector: 'dhp-our-subscriptions',
  templateUrl: './our-subscriptions.component.html',
  styleUrls: ['./our-subscriptions.component.scss'],
  imports: [TranslatePipe, RouterLink],
})
export class OurSubscriptionsComponent {
  readonly subtitle = input<string>()
}
